import { render, staticRenderFns } from "./ForumNotifyDialog.vue?vue&type=template&id=5b6a9904"
import script from "./ForumNotifyDialog.vue?vue&type=script&lang=js"
export * from "./ForumNotifyDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports